<template>
  <div>
    <!-- 面包屑组件 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/courseList'}">课程管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{isEdit?'编辑课程':'添加课程'}}</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 内容卡片 -->
    <el-card>
      <div slot="header" class="clearfix">
        <span>{{isEdit?'编辑课程':'添加课程'}}</span>
      </div>
      <div>
        <el-form label-width="160px" :rules="rules" ref="fromData" :model="fromData" >
            <div>
                <h5 class="">基本信息</h5>
            </div>
            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="选择课程类型" prop="type">
                        <el-radio :disabled="isEdit" v-model="fromData.type" :label="1" value="1">1对1</el-radio>
                        <el-radio :disabled="isEdit" v-model="fromData.type" :label="2" value="2">班课</el-radio>
                        <span class="wran_tips">(创建后不能修改课程类型)</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="课程名称" prop="name">
                        <el-input placeholder="不超过50个字符" maxlength="50" v-model="fromData.name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="单课时长" prop="longTimeOf">
                    <el-input placeholder="单课时长为5的倍数" v-model="fromData.longTimeOf" suffix="分钟">
                      <template>
                        <slot slot="suffix" class="input-slot">分钟</slot>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="薪酬基数" label-position="top" prop="basicSalary">
                        <el-input v-model="fromData.basicSalary"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="累计增加基数" label-position="top" prop="addToSalary">
                        <el-input v-model="fromData.addToSalary"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item label="授课老师" prop="teacherId">
                    <el-select v-model="fromData.teacherId" placeholder="请选择">
                      <el-option
                        v-for="item in teacherList"
                        :key="item.id"
                        :label="item.realname + '（' + item.phone + '）'"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="课程详情介绍" prop="description">
                        <el-input type="textarea" v-model="fromData.description"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
      </div>
    </el-card>

    <div class="footer-nav">
          <el-button type="primary" @click="submitForm('fromData')">确定</el-button>
          <el-button @click="resetForm('fromData')">取消</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        id:'',
        fromData:{
            type:'2',
            name: '',
            setMealId:'',
            longTimeOf:'',
            teacherId: '',
            basicSalary:'',
            addToSalary:'',
            deductTimes:'',
            description:'',
            id:''
        },
        isEdit: false,
        // 套餐列表
        suitList:[],
        // 学管师列表
        teacherList:[],
        // 校验规则
        rules: {
          type: [
            { required: true, message: '请选择课程类型', trigger: 'blur' }
          ],
          name:[
            { required: true, message: '请输入课程名称', trigger: 'blur' }
          ],
          teacherId:[
            { required: true, message: '请选择授课老师', trigger: 'blur' }
          ],
          longTimeOf:[
            { required: true, message: '请输入单课时长', trigger: 'blur' }
          ],
          // deductTimes:[
          //   { required: true, message: '请输入每次扣除课时', trigger: 'blur' }
          // ],
        }
      };
    },
    created() {
        // this.getSetMealList();
        this.getTeacherList();
        this.initData();
    },
    methods: {
      async addCourse() {
        let url = this.isEdit?'/ea/student/course/edit':"/ea/student/course/add"
        const { data: res } = await this.$http.post(url,this.fromData);
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message.success(this.isEdit?"编辑课程成功":"新增课程成功");
        this.$router.push({
            path: '/courseList',
        })
      },
      // 获取所有套餐信息
      async getSetMealList() {
        const { data: res } = await this.$http.get(`/ea/student/setMeal/getSetMealList`);
        if (res.code !== 200)
        return this.$message.error(res.message);
        this.suitList = res.result;
      },
      // 获取所有教师信息
      async getTeacherList() {
        const { data: res } = await this.$http.get(`/ea/sys/user/getTeacherList`);
        if (res.code !== 200)
        return this.$message.error(res.message);
        this.teacherList = res.result;
      },
      initData() {
          let that = this
          let params = this.$route.params;
          if(params && params.type=='edit'){
              this.fromData = params.recordDate
              this.isEdit = true;
          }else{
            this.fromData.type = 2
          }
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addCourse();
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.$router.push("/courseList");
      }
  },
};
</script>

<style lang="less" scoped>
  /deep/ .el-upload__input{
    display: none;
  }
  .wran_tips {
      color: red;
      font-weight: 400;
  }
</style>
